import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchPharmacies } from '../../redux/slices/pharmacySlice';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import { useUserData } from '../../hooks/useUserData';

const HeaderCard = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: 'white',
  borderRadius: 16,
  boxShadow: '0 8px 32px rgba(102, 126, 234, 0.3)',
  marginBottom: theme.spacing(3),
  padding: theme.spacing(2, 3),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const PharmacyList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pharmacies = useSelector(state => state.pharmacy.pharmacies);
  const status = useSelector(state => state.pharmacy.status);
  const { defaultFacility } = useUserData();

  // Fetch pharmacies when facility is available
  useEffect(() => {
    if (defaultFacility?.id) {
      console.log('PharmacyList: Fetching pharmacies for facility:', defaultFacility.id);
      dispatch(fetchPharmacies(defaultFacility.id));
    }
  }, [dispatch, defaultFacility?.id]);

  const handleAddNew = () => {
    navigate('/admin/pharmacies/create');
  };

  const handleEdit = (pharmacy) => {
    navigate(`/admin/pharmacies/${pharmacy.id}/edit`);
  };

  if (status === 'loading') {
    return <div>Loading...</div>;
  }

  return (
    <Box sx={{ p: 3 }}>
      <HeaderCard>
        <Typography variant="h5" component="h1" sx={{ fontWeight: 700, color: 'white', mb: 0 }}>
          Pharmacy Management
        </Typography>
        <Button
          variant="contained"
          sx={{
            background: 'rgba(255,255,255,0.15)',
            color: 'white',
            fontWeight: 600,
            boxShadow: 'none',
            '&:hover': { background: 'rgba(255,255,255,0.25)' },
          }}
          startIcon={<AddIcon />}
          onClick={handleAddNew}
        >
          Add New Pharmacy
        </Button>
      </HeaderCard>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Address</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Fax</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pharmacies.map((pharmacy) => (
              <TableRow key={pharmacy.id}>
                <TableCell>{pharmacy.name}</TableCell>
                <TableCell>{pharmacy.address}</TableCell>
                <TableCell>{pharmacy.phone}</TableCell>
                <TableCell>{pharmacy.fax}</TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={() => handleEdit(pharmacy)}
                  >
                    Edit
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PharmacyList;
